/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archiveconfirmtitle2Inputs */



/**
* | output |
* | --- |
* | "Move to archive?" |
*
* @param {Archiveconfirmtitle2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const archiveconfirmtitle2 = /** @type {((inputs?: Archiveconfirmtitle2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archiveconfirmtitle2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Move to archive?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Mover al archivo?")
	return /** @type {LocalizedString} */ ("Отправить в архив?")
});
export { archiveconfirmtitle2 as "archiveConfirmTitle" }